<div class="report-model">

    <div class="report-model-header">
        <div class="info">
            <h3>{{'reports.residentialRentalIncome' | translate}}</h3>
        </div>


    </div>
    <!-- <app-residential-detail-table
    class="rwi-propertyDetail-table"
    [tableName]="'incomeAssessment'"
    [showLoader]="!rentalIncomeCountLoading"
    [tableColumns]="rentalIncomeCountColumns"
    [dataLength]="rentalIncomeCount"
    [tableData]="rentalIncomeCountData"
    [allowExcelDownload]="true"
    [hidePagination]="true"
    (sort)="sortData($event, 1)"
    (excelDownload)="downloadExcel('property_details_residential_rental_income')"
    [downloadLoading]="reportPropertyDetailService.downloadLoading['d']"
    >
</app-residential-detail-table> -->


</div>
